import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl, NgForm, FormGroupDirective } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { NetworkService } from './../../../services/network.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'single-password-input',
  templateUrl: './single-password-input.component.html',
  styleUrls: ['./single-password-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SinglePasswordInputComponent implements OnInit {
  passwordForm: FormGroup;
  showDetails: boolean = true;
  matcher = new MyErrorStateMatcher();
  hidePasswordInfo: boolean = false;
  showPasswordCofirm: boolean = false;

  @Output() passwordValidAndChanged = new EventEmitter();

  
  constructor(private fb: FormBuilder, private _cdr: ChangeDetectorRef, private networkService: NetworkService,
    private _snackBar: MatSnackBar) { }

  changed(){

  }

  onStrengthChanged(strength: number) {
    console.log('password strength = ', strength);
    if(strength == 100){
     this.hidePasswordInfo = true;
      this.showPasswordCofirm = true;
      let password: string = this.passwordForm.get("password").value;
      this.passwordValidAndChanged.emit(password)
     
    }else{
      this.hidePasswordInfo = false;
      this.showPasswordCofirm = false;
    }
    //this._cdr.detectChanges();
  }

  ngOnInit(): void {

    this.passwordForm = this.fb.group({
      password: ['', [Validators.required]]
    }, {})
  }

  updatePassword(){
    let newPassword = this.passwordForm.get("password").value;
    let email = "";
    let currentPassword = this.passwordForm.get("currentPassword").value;

    this.networkService.updateMyPassword(currentPassword, newPassword, email).then((data)=>{
      if(data.body.data.state == 1){
        this._snackBar.open("Passwort erfolgreich geändert!");
        location.reload();
      }else{
        this._snackBar.open("Ihr aktuelles Passwort ist falsch.")
      }
    }).catch(()=>{
      console.log("Unerwarteter Fehler")
    })

  }

}





export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}